import jwtDecode from 'jwt-decode';
import { LocalStorageKeys } from '../app.constants';
import { store } from '../store';
import Utils from '../Utils';

export interface IToken {
  regions: string[];
  userName: string;
  role: string;
  userId: string;
}

export function logout() {
  localStorage.removeItem(LocalStorageKeys.jwt);
  window.location.assign('/');
  // window.location.assign(process.env.VUE_APP_LOGIN_URI);
}

export function isAuthenticated() {
  return store.state.isAuthenticated;
}

export function isAdmin() {
  return (store.state.token as IToken).role === 'Admin';
}

export function decodeToken(jwt: string): IToken | {} {
  let token;
  try {
    token = jwtDecode(jwt);
  } catch (error) {
    // disregard if broken token
  }

  if (token) {
    const userId = token.sub;
    const userName = token.username;
    const regionsJson = token.regions;
    const userRole =
      token['http://schemas.microsoft.com/ws/2008/06/identity/claims/role'];
    return {
      regions: Utils.jsonParse<string[]>(regionsJson) || [],
      role: userRole,
      userId: userId || '',
      userName: userName || '',
    };
  }

  return {};
}
